import { Alert, Box, List, Text, Title } from "@mantine/core";
import { generatePath, Link, useLocation } from "react-router";
import { useSiteWizard } from "../../../hooks/useSiteWizard";
import { AlertPresets } from "../../../mantine/mantinePresets";
import { ROUTES } from "../../../routes";
import urls from "../../../urls";
import {
  MissingDataComponentName,
  MissingDataTypes
} from "../../../utils/backend-types";
import { AnchorLink } from "../../AnchorLink/AnchorLink";

type DirektvermarktungLocationState = {
  projectId?: string;
  siteId?: string;
};

function DirektvermarktungMissingAssignmentToContractAlert() {
  const { state } = useLocation() as { state?: DirektvermarktungLocationState };
  const projectId = state?.projectId;
  const siteId = state?.siteId;

  const { data: siteWizard } = useSiteWizard(
    siteId ? parseInt(siteId) : undefined
  );

  if (!projectId || !siteId || !siteWizard) {
    return null;
  }

  const generators = siteWizard.phases.dataloadauthority.missingData.filter(
    (data) =>
      data.componentName === MissingDataComponentName.GENERATOR &&
      data.missingDataType === MissingDataTypes.CONTRACT
  );

  const siteUrl = generatePath(ROUTES.site.entry, {
    projectId,
    siteId
  });

  if (generators.length === 0) {
    return (
      <Alert
        color={AlertPresets.success.color}
        icon={AlertPresets.success.icon}
      >
        <Title fw={600} order={5}>
          Alle Erzeuger sind einem Vertrag zugeordnet
        </Title>
        <Box>
          <List>
            <List.Item>
              Kehren Sie zu Ihrer <Link to={siteUrl}>Liegenschaft</Link> zurück
              und fahren Sie mit der Vermarkter Vollmacht fort.
            </List.Item>
            <List.Item>
              Laden Sie sich die Vorlage herunter und schicken Sie das
              unterschriebene Dokument an{" "}
              <AnchorLink href="mailto:support@node.energy" target="_self">
                support@node.energy
              </AnchorLink>
              .
            </List.Item>
            <List.Item>
              Wir arbeiten am Upload innerhalb von opti.node.
            </List.Item>
          </List>
        </Box>
      </Alert>
    );
  }
  return (
    <Alert color={AlertPresets.warning.color} icon={AlertPresets.warning.icon}>
      <Title fw={600} order={5}>
        Erzeuger sind keinem Vertrag zugeordnet
      </Title>
      <Text>
        Einige Ihrer Erzeuger sind keinem Vertrag zugeordnet. Bitte ordnen Sie
        die Erzeuger den entsprechenden Verträgen zu.
      </Text>

      <List withPadding>
        {generators.map((generator) => (
          <List.Item key={generator.id}>{generator.name}</List.Item>
        ))}
      </List>

      <Text>
        Kehren Sie dann zu Ihrer <Link to={siteUrl}>Liegenschaft</Link> zurück.
      </Text>

      <Text my="sm">
        Bei Fragen stehen Ihnen unsere{" "}
        <AnchorLink href={urls.optiSupport()}>opti.node-Hilfe</AnchorLink> und
        unser{" "}
        <AnchorLink href="mailto:support@node.energy" target="_self">
          Support-Team
        </AnchorLink>{" "}
        gerne zur Verfügung.
      </Text>
    </Alert>
  );
}

export { DirektvermarktungMissingAssignmentToContractAlert };
